import { render, staticRenderFns } from "./CelebrationForm.vue?vue&type=template&id=4eb863e5"
import script from "./CelebrationForm.vue?vue&type=script&lang=js"
export * from "./CelebrationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports